import * as Sentry from "@sentry/react";
const DSN = "https://8e1c366ae8b6570d26993a814af8d0b5@o4508817991335936.ingest.us.sentry.io/4508818375639040";
const VERSION = "2.0.37.0";
const PROD_HOST = "holacarrentals.com";
export function initSentry(bundle) {
    if (window.location.hostname !== PROD_HOST)
        return;
    Sentry.init({
        dsn: DSN,
        release: VERSION,
        environment: "production",
        integrations: [],
        allowUrls: [/https?:\/\/((cdn|www)\.)?holacarrentals\.com/],
        denyUrls: [
            /pandectes|pandect\.es/i,
            /otlp-http-production\.shopifysvc\.com/,
            /shopifycloud\/storefront/,
        ],
        tracesSampleRate: 0.1,
        initialScope: {
            tags: { bundle },
        },
    });
    addEventListener("load", () => {
        setTimeout(() => {
            const nav = performance.getEntriesByType("navigation")[0];
            if (!nav)
                return;
            const ttfb = Math.round(nav.responseStart - nav.requestStart);
            const dns = Math.round(nav.domainLookupEnd - nav.domainLookupStart);
            const tcp = Math.round(nav.connectEnd - nav.connectStart);
            const pageLoad = Math.round(nav.loadEventEnd - nav.fetchStart);
            let speed = "fast";
            if (ttfb > 2000 || pageLoad > 8000)
                speed = "slow";
            else if (ttfb > 800 || pageLoad > 4000)
                speed = "medium";
            Sentry.setTags({
                "perf.speed": speed,
                "perf.ttfb": String(ttfb),
                "perf.dns": String(dns),
                "perf.tcp": String(tcp),
                "perf.pageLoad": String(pageLoad),
            });
        }, 0);
    });
}
